<template>
  <el-card
    shadow="hover"
    class="mainCard"
  >
    <div slot="header">
      LGPR
    </div>
    <div class="content">
      <div class="lgprCreate">
        <el-steps
          :active="active"
          align-center
          finish-status="success"
        >
          <el-step title="Add Stakeholder" />
          <el-step title="Scheduling" />
          <el-step title="Confirm" />
        </el-steps>

        <div
          v-if="active === 0"
          class="stepContent"
        >
          <Stakeholder
            :stakeholders.sync="stakeholders"
          />
        </div>
        <div
          v-if="active === 1"
          class="stepContent"
        >
          <Schedule
            :lgpr.sync="localLgpr"
          />
        </div>
        <div
          v-show="active >= 2"
          class="stepContent"
        >
          <Confirm @confirm="confirmLgpr" />
        </div>

        <el-button
          style="margin-top: 12px;"
          :disabled="previousDisabled"
          @click="previous"
        >
          Previous
        </el-button>
        <el-button
          style="margin-top: 12px;"
          :disabled="nextDisabled"
          @click="next"
        >
          Next
        </el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import Stakeholder from './createSteps/Stakeholder.vue';
import Schedule from './createSteps/Schedule.vue';
import Confirm from './createSteps/Confirm.vue';

export default {
  components: {
    Stakeholder,
    Schedule,
    Confirm,
  },

  props: {
    lgpr: {
      type: Object,
      default() {
        return {
          id: 0,
          number: 0,
          status: 'draft',
          start_date: this.$moment().format('YYYY-MM-DD'),
          end_date: null,
          reminder_1: null,
          reminder_2: null,
          reminder_3: null,
        };
      },
    },
  },

  data() {
    return {
      active: 0,
      stakeholders: [],
      localLgpr: {}, // used to pass lgpr to children components
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    nextDisabled() {
      if (!this.localLgpr) return false;

      if (this.active === 0) {
        if (this.stakeholders.length < 4) {
          return true;
        }
      }
      if (this.active === 1) {
        if (!this.localLgpr.end_date || this.localLgpr.end_date === '') {
          return true;
        }
      }
      if (this.active === 2) {
        return true;
      }
      return false;
    },

    previousDisabled() {
      if (this.active === 0) {
        return true;
      }
      return false;
    },
  },

  watch: {
    lgpr: {
      immediate: true,
      handler(lgpr) {
        this.localLgpr = lgpr;
      },
    },
  },

  created() {
    this.getSupporter();
  },

  methods: {
    async getSupporter() {
      const response = await api.getSupporter();
      this.stakeholders = [
        {
          first_name: this.user.user.first_name,
          last_name: this.user.user.last_name,
          email: this.user.user.email,
          phone_number: '',
          org_relationship: 'self',
          survey_language: 'english',
        },
        ...response.data,
      ];
    },

    confirmLgpr() {
      this.active = 4;
      this.$emit('update:lgpr', this.localLgpr);
    },

    previous() {
      this.active -= 1;
      if (this.active < 0) this.active = 2;
    },

    next() {
      this.active += 1;
      if (this.active > 2) this.active = 0;
    },
  },
};
</script>
